import { rootApi } from "../../api/rootApi";

export const appUserChangeApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    createChangeAppUser: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/usertype-change/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    getChangeAppUser: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/usertype-change`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    getChangeAppUserCount: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/usertype-change/count`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

  }),
});

export const {
  useCreateChangeAppUserMutation,
  useGetChangeAppUserMutation,
  useGetChangeAppUserCountMutation
 
} = appUserChangeApi;
